"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _actions = require("../actions");

var initialState = null;

var _default = (0, _fluxActions.handleActions)((0, _defineProperty2.default)({}, _actions.FetchCustomHostedDomainsActionTypes.SUCCESS, function (customHostedDomains, action) {
  return action.payload.data;
}), initialState);

exports.default = _default;
module.exports = exports.default;